import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-play-circle-line text-primary-500 mr-2"></i>
            吃瓜视频精选
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            热门事件视频解读，让吃瓜更有画面感
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {mediaData.map((item) => (
              <div
                key={item.id}
                className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all hover:translate-y-[-2px]"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/60 text-background-50 text-xs whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug mb-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    <span>{item.views} 次播放</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}